module.exports = __webpack_public_path__ + "images/emoji/snail.b0e993300a350ddac1ea.png";